import { Component, inject } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
	selector: "ic-not-found",
	templateUrl: "./not-found.component.html",
	styleUrls: ["./not-found.component.scss"],
	standalone: false,
})
export class NotFoundComponent {
	private readonly router = inject(Router);
	private readonly route = inject(ActivatedRoute);

	goToResidentOverview() {
		const { patient } = this.route.snapshot.params;

		this.router.navigate([patient, "overview", "home", "tasks"]);
	}
}
